import React from "react";
import { useRoutes } from "react-router-dom";
import { withRouter } from "../../util/with-router";
import { TransitionGroup } from "react-transition-group";
import * as paths from "../../constants/route-paths";
import Schedule from "./schedule";
import AllocationsView from "./allocations-view";
import ViewTimeSheet from "./view-timesheet";
import RBACApplicationAuth from "../../layout/rbac";
import ImportTimesheet from "./import";
import WeeklyTimesheetPage from "./weekly-timesheet";

function CustomRoutes({ location }) {

  let element = useRoutes([
    {
      path: paths.SCHEDULE,
      element: <RBACApplicationAuth moduleURL={location.pathname} component={Schedule} />,
    },
    {
      path: paths.ALLOCATIONS,
      element: <RBACApplicationAuth moduleURL={location.pathname} component={AllocationsView} />,
    },
    {
      path: paths.VIEW_TIMESHEET,
      element: <RBACApplicationAuth moduleURL={location.pathname} component={ViewTimeSheet} />,
    },
    {
      path: paths.IMPORT_TIMESHEET,
      element: <RBACApplicationAuth moduleURL={location.pathname} component={ImportTimesheet} />,
    },
    {
      path: paths.TIMESHEET_INPUT,
      element: <RBACApplicationAuth moduleURL={location.pathname} component={WeeklyTimesheetPage} />,
    }
  ]);

  return element;
}

class Root extends React.PureComponent {
  render() {
    const { location } = this.props;
    return (
      <div className="clearfix" style={{ width: "100%" }}>
        <TransitionGroup>
          <CustomRoutes location={location} />
        </TransitionGroup>
      </div>
    );
  }
}
export default withRouter(Root);
